<template>
  <div>
    <div class="card">
      <div class="card_title">发函进度</div>
      <div class="card_content steps">
        <el-steps :active="form.lcjd" :space="300">
          <el-step title="发函申请">
            <template slot="description">
              <div>{{ form.sqrxx }}</div>
              <div>{{ form.createtime }}</div>
            </template>
          </el-step>
          <el-step title="发函完成" description="">
            <template slot="description">
              <div>{{ form.qdrxx }}</div>
              <div>{{ form.qdtime }}</div>
            </template>
          </el-step>
        </el-steps>
      </div>
    </div>
    <div class="card">
      <div class="card_title">
        <div>发函信息</div>
      </div>
      <div class="card_content">
        <div class="row">
          <div class="col">
            <span>收件人：</span>
            <span>{{ form.sjr }}</span>
          </div>
          <div class="col">
            <span>联系方式：</span>
            <span>{{ form.lxfs }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <span>收件地址：</span>
            <span>{{ form.sjdz }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <span>其他备注：</span>
            <span>{{ form.bz }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card_title">
        <div>相关附件</div>
      </div>
      <div class="card_content">
        <el-table
          :data="fileList"
          fit
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
        >
          <el-table-column
            label="附件类型"
            prop="wjlx"
            min-width="80px"
            :show-overflow-tooltip="true"
            align="center"
          ></el-table-column>
          <el-table-column
            label="附件名"
            prop="filename"
            :show-overflow-tooltip="true"
            min-width="250px"
            align="center"
          ></el-table-column>
          <el-table-column
            label="文件大小"
            prop="filesize"
            :show-overflow-tooltip="true"
            min-width="80px"
            align="center"
          ></el-table-column>
          <el-table-column
            label="上传人"
            prop="uploader"
            min-width="100px"
            align="center"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            label="上传时间"
            prop="uploadtime"
            min-width="100px"
            align="center"
          ></el-table-column>
          <el-table-column label="操作" min-width="100px" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="viewFile(scope.row)">
                预览
              </el-button>
              <el-button type="text" @click="downloadFile(scope.row)"
                >下载</el-button
              >
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
      </div>
    </div>
    <div class="card upload">
      <div class="card_title">
        <div>发函处理</div>
      </div>
      <div class="card_content">
        <div class="row">
          <div class="col">
            <span>邮寄回执：</span>
            <span>
              <el-upload
                action="#"
                class="upload-demo"
                ref="yjhzUpload"
                :headers="headers"
                :file-list="yjhzList"
                :auto-upload="false"
                multiple
              >
                <el-button icon="el-icon-upload" size="small" plain
                  >选择附件</el-button
                >
              </el-upload>
              <div class="tips">单个文件不能超过20M</div>
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <span>电子函件：</span>
            <span
              ><el-upload
                action="#"
                class="upload-demo"
                ref="dzhjUpload"
                :headers="headers"
                :file-list="dzhjList"
                :auto-upload="false"
                multiple
              >
                <el-button icon="el-icon-upload" size="small" plain
                  >选择附件</el-button
                >
              </el-upload>
              <div class="tips">单个文件不能超过20M</div>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { insertFhsq, uploadFile } from "@/api/zxlc";

export default {
  components: {},
  computed: {
    ...mapGetters(["deptUser", "user"]),
  },
  props: ["mxParams"],
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      headers: {
        "x-token": localStorage.getItem("token"),
      },
      form: {
        button: {},
      },
      yjhz: null,
      dzhj: null,
      fileList: [],
      yjhzList: [],
      dzhjList: [],
      rules: {},
      applyDialog: false,
    };
  },
  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    this.form = this.mxParams.form;
    this.fileList = this.mxParams.fileList;
  },
  mounted() {},

  methods: {
    saveForm() {
      const data = {
        dzhj: this.dzhj,
        yjhz: this.yjhz,
        id: this.mxParams.fhd ? this.mxParams.fhd : this.mxParams.fhid,
        type: 1,
      };
      insertFhsq(data).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.$emit("giveFather");
        }
      });
    },
    submitUpload() {
      if (this.$refs.yjhzUpload.uploadFiles.length == 0) {
        this.$message.error("请上传邮寄回执！");
        return;
      }
      if (this.$refs.dzhjUpload.uploadFiles.length == 0) {
        this.$message.error("请上传电子函件！");
        return;
      }
      Promise.all([this.uploadDzhj(), this.uploadYjhz()]).then((res) => {
        this.$message.success("上传成功！");
        this.saveForm();
      });
    },
    uploadYjhz() {
      return new Promise((resolve, reject) => {
        this.$refs.yjhzUpload.submit();
        let { uploadFiles } = this.$refs.yjhzUpload;
        let form = new FormData();
        uploadFiles.forEach((item, index) => {
          form.append("files", item.raw);
        });
        form.append("wjlx", 2);
        form.append("lclx", 1);
        //上传文件
        uploadFile(form).then((res) => {
          if (res.code == 0) {
            this.yjhz = res.data;
            resolve(res);
          } else {
            this.$message({
              type: "error",
              message: res.msg,
              showClose: true,
            });
            reject(res);
          }
        });
      });
    },
    uploadDzhj() {
      return new Promise((resolve, reject) => {
        this.$refs.dzhjUpload.submit();
        let { uploadFiles } = this.$refs.dzhjUpload;
        let form = new FormData();
        uploadFiles.forEach((item, index) => {
          form.append("files", item.raw);
        });
        form.append("wjlx", 3);
        form.append("lclx", 1);
        //上传文件
        uploadFile(form).then((res) => {
          if (res.code == 0) {
            this.dzhj = res.data;
            resolve(res);
            //
          } else {
            this.$message({
              type: "error",
              message: res.msg,
              showClose: true,
            });
            reject(res);
          }
        });
      });
    },
    viewFile(row) {
      sessionStorage.setItem("previewurl", row.previewurl);
      let routeData = this.$router.resolve({
        path: "/officePreview",
        component: () => import("@/views/zxlc/officePreview/index"),
      });
      window.open(routeData.href, "_blank");
    },
    downloadFile(row) {
      const filePath = row.url;
      const fileName = row.filename;
      const url =
        window.g.apiUrl +
        "system/downloadFile?fileName=" +
        fileName +
        "&filePath=" +
        filePath;
      // 组装a标签
      const elink = document.createElement("a");
      // 设置下载文件名
      elink.download = fileName;
      elink.style.display = "none";
      elink.href = url;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    getSon() {
      this.applyDialog = false;
      this.viewDialog = false;
      this.getData();
    },
    handleToApply() {
      this.mxParams = {
        ...this.form,
        xmbh: this.mxParams.xmbh,
        hjfj: this.form.hjfj[0].fileid,
        fhd: this.mxParams.fhd,
        id: this.form.id,
      };
      this.applyDialog = true;
    },
    handleSubmitApply() {
      this.$refs.apply.submitUpload();
    },
  },
};
</script>

<style lang="less" scoped>
.card {
  padding: 15px 15px 15px 0;
  border-bottom: 1px solid #ccc;

  .card_title {
    padding-bottom: 15px;
    font-size: 16px;
    display: flex;
    .btn {
      height: 21px;
      padding: 0 15px;
      background-color: #108ee9;
      color: #fff;
      border-radius: 5px;
      font-size: 12px;
      line-height: 21px;
      margin-left: 15px;
      cursor: pointer;
    }
  }
  .card_content {
    .row {
      height: 36px;
      line-height: 34px;
      display: flex;
      .col {
        display: flex;
        min-width: 300px;
        span:nth-of-type(1) {
          width: 100px;
        }
      }
    }
  }

  .steps {
    padding-left: 60px;
  }
}
.card:nth-last-child(1) {
  border-bottom: 0;
}
.card.upload {
  border-bottom: 0;
  .row {
    height: auto;
    margin-bottom: 15px;
    text-align: left;
    .tips {
      color: #aaa;
    }
  }
}
::v-deep .vue-treeselect__multi-value-item {
  display: block;
  height: 36px;
  line-height: 36px;
}
::v-deep .vue-treeselect__multi-value {
  height: 40px;
}
</style>